<template>
  <div class="siteMap">
    <div class="HomeContainer">
      <div class="lineContainer">
        <div class="line">
          <router-link class="title" to="/">{{l("中锻材首页")}}</router-link>
          <div class="subTitleContainer">
            <router-link class="subTitle" to="/home/quotation"
              >{{l("现货卖场")}}</router-link
            >
            <router-link class="subTitle" to="/home/purchase_forging"
              >{{l("锻件定制")}}</router-link
            >
            <router-link class="subTitle" to="/home/purchase_material"
              >{{l("原料求购")}}</router-link
            >
            <router-link class="subTitle" to="/home/raise"
              >{{l("钢厂拼单")}}</router-link
            >
            <!-- <router-link class="subTitle" to="/home/purchase_piece"
              >{{l("零切交易")}}</router-link
            > -->
            <router-link class="subTitle" to="/home/good_business"
              >{{l("优选好商")}}</router-link
            >
            <router-link class="subTitle" to="/home/inspect_business"
              >{{l("热处理")}}</router-link
            >
            <router-link class="subTitle" to="/home/forum"
              >{{l("周边论坛")}}</router-link
            >
          </div>
        </div>
      </div>

      <div class="lineContainer">
        <div class="line">
          <router-link class="title" to="/home/article">{{l("行情中心")}}</router-link>
          <div class="subTitleContainer">
            <router-link class="subTitle" to="/home/article?type=动态"
              >{{l("动态")}}</router-link
            >
            <router-link class="subTitle" to="/home/article?type=聚焦"
              >{{l("聚焦")}}</router-link
            >
            <router-link class="subTitle" to="/home/article?type=解读"
              >{{l("解读")}}</router-link
            >
            <router-link class="subTitle" to="/home/article?type=周评"
              >{{l("周评")}}</router-link
            >
          </div>
        </div>
      </div>

      <div class="lineContainer">
        <div class="line">
          <router-link class="title" to="/home/quotation">{{l("现货卖场")}}</router-link>
          <div class="subTitleContainer">
            <router-link
              v-for="category of $store.state.basicInfo.categoryList_quotation"
              :key="category.id"
              class="subTitle"
              :to="'/home/quotation?category_id=' + category.id"
            >
              {{ category.name }}
            </router-link>
          </div>
        </div>
      </div>

      <div class="lineContainer">
        <div class="line">
          <router-link class="title" to="/home/good_business"
            >{{l("优选好商")}}</router-link
          >
          <div class="subTitleContainer">
            <router-link
              v-for="tag of $store.state.basicInfo.tagList.good_business"
              :key="tag.id"
              class="subTitle"
              :to="'/home/good_business?tag_id=' + tag.id"
            >
              {{ tag.name }}
            </router-link>
          </div>
        </div>
      </div>

      <div class="lineContainer">
        <div class="line">
          <router-link class="title" to="/home/forum">{{l("周边论坛")}}</router-link>
          <div class="subTitleContainer">
            <router-link
              v-for="tag of $store.state.basicInfo.tagList.forum"
              :key="tag.id"
              class="subTitle"
              :to="'/home/forum?tag_id=' + tag.id"
            >
              {{ tag.name }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SiteMap",
  data() {
    return {};
  },
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.siteMap {
  background: #fff;
  .lineContainer {
    margin: 0 40px;
    padding: 35px 0;
    border-bottom: 1px solid $borderPlainColor;

    &:last-child {
      border-bottom: none;
    }
    .line {
      .title {
        font-size: 16px;
        border-left: 4px solid $warningColor;
        padding-left: 8px;

        &:hover {
          color: $warningColor;
        }
      }
      .subTitleContainer {
        display: flex;
        flex-wrap: wrap;
        font-size: 15px;
        .subTitle {
          margin-top: 25px;
          padding: 0 20px;
          position: relative;
          min-width: 75px;
          box-sizing: border-box;
          text-align: center;
          &::after {
            content: "";
            position: absolute;
            right: 0;
            top: 5px;
            width: 1px;
            height: 10px;
            // background: $borderColor;
            background: #ccc;
          }

          &:last-child::after {
            display: none;
          }

          &:hover {
            color: $warningColor;
          }
        }
      }
    }
  }
}
</style>

